module.exports = {
      id: "check-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-84b14bdf361f52431cd97a9452f94b75.svg#check",
      toString: function () {
        return this.url;
      }
    }